import React, { useMemo, useState } from 'react';

const AttentionCard = ({ copy, isRTL = false }) => {
  const [activeAlertIndex, setActiveAlertIndex] = useState(0);
  const [showAlertFeed, setShowAlertFeed] = useState(false);
  const hasAlerts = copy.attentionAlerts.length > 0;

  const activeAlert = useMemo(
    () => copy.attentionAlerts[activeAlertIndex] || copy.attentionAlerts[0],
    [copy.attentionAlerts, activeAlertIndex]
  );

  return (
    <>
      <article className="executive-overview-panel executive-overview-attention">
        <div className="executive-overview-attention-head">
          <div className="executive-overview-attention-heading-group">
            <div className="executive-overview-card-title">{copy.attentionTitle}</div>
            <span className="executive-overview-alert-badge">{copy.attentionAlerts.length}</span>
          </div>
          <button
            type="button"
            className="executive-overview-see-all"
            disabled={!hasAlerts}
            onClick={() => setShowAlertFeed(true)}
          >
            {copy.seeAll}
          </button>
        </div>

        <div className="executive-overview-attention-preview">
          {hasAlerts ? (
            <p className="executive-overview-attention-copy">
              <span className={activeAlert.tone}>{activeAlert.title}:</span> {activeAlert.body}
            </p>
          ) : (
            <p className="executive-overview-attention-copy">
              {isRTL ? 'لا توجد تنبيهات مباشرة متاحة بعد.' : 'No live attention alerts are available yet.'}
            </p>
          )}
        </div>

        <div className="executive-overview-attention-actions">
          <button
            type="button"
            className="executive-overview-nav-btn"
            disabled={!hasAlerts}
            onClick={() => setActiveAlertIndex((prev) => (prev === 0 ? copy.attentionAlerts.length - 1 : prev - 1))}
          >
            <i className={`fa-solid ${isRTL ? 'fa-circle-chevron-right' : 'fa-circle-chevron-left'}`} />
            {copy.prev}
          </button>
          <button
            type="button"
            className="executive-overview-nav-btn"
            disabled={!hasAlerts}
            onClick={() => setActiveAlertIndex((prev) => (prev + 1) % copy.attentionAlerts.length)}
          >
            {copy.next}
            <i className={`fa-solid ${isRTL ? 'fa-circle-chevron-left' : 'fa-circle-chevron-right'}`} />
          </button>
        </div>
      </article>

      {showAlertFeed && (
        <div className={`executive-overview-modal-backdrop${isRTL ? ' rtl' : ''}`} onClick={() => setShowAlertFeed(false)}>
          <div
            className="executive-overview-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="executive-overview-modal-head">
              <div>
                <h3>{copy.feedTitle}</h3>
                <p>{copy.feedSubtitle}</p>
              </div>
              <button
                type="button"
                className="executive-overview-modal-close"
                onClick={() => setShowAlertFeed(false)}
              >
                <i className="fa-solid fa-xmark" />
                {copy.feedClose}
              </button>
            </div>

            <div className="executive-overview-alert-feed">
              {copy.attentionAlerts.map((alert, index) => (
                <article key={`${alert.title}-${index}`} className="executive-overview-alert-feed-item">
                  <div className={`executive-overview-alert-feed-badge ${alert.tone}`}>{alert.title}</div>
                  <p>{alert.body}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AttentionCard;
